module.exports = __webpack_public_path__ + "img/user_detailed_activity.edc91625.jpg";